import {
  endDateChanged,
  searchBarChanged,
  startDateChanged,
  stateBarChanged,
} from "./clientSideSearchActionCreators";
import Store from "../Store";
import { axiosInstance } from "../axios_Instanse";

export const searchActiveOrders = (orderObject, searchInfo) => {
  //order array will be passed to this to make a live searchBar
  const { searchBar, stateValue, start_date, end_date } = searchInfo;

  return orderObject
    .filter((order) => order.state.includes(stateValue))
    .filter(
      (order) =>
        order.number.includes(searchBar) || order.state.includes(searchBar)
    )
    .filter((order) => order.cDate >= start_date)
    .filter((order) => order.cDate <= end_date);
};

export const searchReadyToSendOrders = (orderObject, searchInfo) => {
  //order array will be passed to this to make a live searchBar

  const { searchBar, start_date, end_date } = searchInfo;
  return orderObject
    .filter((order) => order.number.includes(searchBar))
    .filter((order) => order.cDate >= start_date)
    .filter((order) => order.cDate <= end_date);
};
export const searchHistoryOrders = (orderObject, searchInfo) => {
  //order array will be passed to this to make a live searchBar

  const { searchBar } = searchInfo;
  return orderObject.filter((order) => order?.number?.includes(searchBar));
};
export const clearSearch = () => {
  Store.dispatch(endDateChanged(new Date().toJSON()));
  Store.dispatch(stateBarChanged(""));
  Store.dispatch(startDateChanged(""));
  Store.dispatch(searchBarChanged(""));
};

export const toggle_activity = async (values) => {
  try {
    const { data } = await axiosInstance.post(`/publisher/last_state`, values);

    return data;
  } catch (error) {}
};
export const toggle_online_offline = async (values) => {
  try {
    const { data } = await axiosInstance.post(`/publisher/status`, values);

    return data;
  } catch (error) {}
};
export const utils = {
  today: (date) => {
    date = date ? date : new Date();
    let t = date
      .toLocaleDateString("fa-IR")
      .replace(/([۰-۹])/g, (token) =>
        String.fromCharCode(token.charCodeAt(0) - 1728)
      );
    t = t.split("/");
    t = `${t[0]}/${t[1] < 10 ? "0" : ""}${t[1]}/${t[2] < 10 ? "0" : ""}${t[2]}`;
    return t;
  },
  get_time: (date) => {
    let st = date ? new Date(date) : new Date();
    return `${st.getHours() < 10 ? "0" : ""}${st.getHours()}:${
      st.getMinutes() < 10 ? "0" : ""
    }${st.getMinutes()}:${st.getSeconds() < 10 ? "0" : ""}${st.getSeconds()}`;
  },
  now: (nd) => {
    nd = nd ? new Date(nd) : new Date();
    let h = nd.getHours();
    let m = nd.getMinutes();
    return `${h < 10 ? "0" : ""}${h}:${m < 10 ? "0" : ""}${m}`;
  },
};

export const PagesUrl = () => {
  let menu;
  let pages = [];

  try {
    // eslint-disable-next-line
    menu = JSON.parse(localStorage.menu);
    menu.map((item) => {
      return item.menu_subs.map((i) => {
        let item = { title: i.title, value: i.link };
        return pages.push(item);
      });
    });
  } catch (error) {}

  return { pages };
};

export const Get_day = (date) => {
  return new Date(date).toLocaleDateString("fa-IR", { weekday: "long" });
};
